import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ORG_ACCESS_FAIL = "ADMIN-USER:MODIFY_ORG_ACCESS_FAIL";

export interface ModifyOrgAccessFailAction extends Action {
  type: typeof MODIFY_ORG_ACCESS_FAIL;
  organization: OrganizationKeyName;
}

export const modifyOrgAccessFailAction = (
  organization: OrganizationKeyName
): ModifyOrgAccessFailAction => ({
  type: MODIFY_ORG_ACCESS_FAIL,
  organization,
});
